import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { Paragraph, TextLink } from '@mlc/web-ui-toolkit';
import { Link } from 'react-router-dom';

export const Name = styled(TextLink)`
	color: ${palette.mlcAqua};
	margin: 0;
`;

export const OtherDetails = styled(Paragraph)`
	color: ${palette.mlcVeryDarkGrey};
	margin: 0;
`;

export const RouterLink = styled(Link)`
	color: ${palette.mlcAqua};
	margin: 0;
`;
